import { render, staticRenderFns } from "./ProfileUpdateScreen.vue?vue&type=template&id=4249e77a&"
import script from "./ProfileUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports